import { configureStore } from '@reduxjs/toolkit'
import authReducer from '../features/auth/authSlice'
import { apiSlice } from './api/apiSlice'
import { strapiApiSlice } from './api/strapiApiSlice'
import { bankDepositApi } from '../features/bank-deposits/bankDepositSlice'
import { vipTradingApi } from '../features/vip-trading/vipTradingApiSlice'
import twoFactorModalReducer from '../features/two-factor-modal/twoFactorModalSlice'
import withdrawOtpReducer from '../features/withdraw-otp/withdrawOtpSlice'

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [strapiApiSlice.reducerPath]: strapiApiSlice.reducer,
    [bankDepositApi.reducerPath]: bankDepositApi.reducer,
    [vipTradingApi.reducerPath]: vipTradingApi.reducer,
    auth: authReducer,
    twoFactorModal: twoFactorModalReducer,
    withdrawOtp: withdrawOtpReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(apiSlice.middleware)
      .concat(strapiApiSlice.middleware)
      .concat(bankDepositApi.middleware)
      .concat(vipTradingApi.middleware),
  devTools: true,
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
